"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.initReadyChecks = exports.setUserAgent = exports.initBowser = exports.setRootUAFlags = exports.initNavPreload = void 0;
const common_1 = require("@epic-core/common");
const bowser_1 = __importDefault(require("bowser"));
const epic_games_nav_shared_1 = require("epic-games-nav-shared");
const pako_1 = __importDefault(require("pako"));
const window_or_global_1 = __importDefault(require("window-or-global"));
const defaultEpicGamesNav = {
    browser: {},
};
const initNavPreload = () => {
    if (!window_or_global_1.default._epicGamesNav) {
        window_or_global_1.default._epicGamesNav = defaultEpicGamesNav;
    }
    if (window_or_global_1.default.__server_side_render)
        return;
    if (typeof window_or_global_1.default._epicGamesNav === "string" && /^([0-9]+),/.test(window_or_global_1.default._epicGamesNav)) {
        // EpicGamesNav is pako encoded.
        try {
            const preload = JSON.parse(pako_1.default.inflate(window_or_global_1.default._epicGamesNav.split(","), { to: "string" }));
            window_or_global_1.default._epicGamesNav = preload;
        }
        catch (error) {
            // Ignore.
            window_or_global_1.default._epicGamesNav = defaultEpicGamesNav;
        }
    }
};
exports.initNavPreload = initNavPreload;
const setRootUAFlags = (userAgent) => {
    if (!window_or_global_1.default._epicGamesNav || !userAgent) {
        return;
    }
    window_or_global_1.default._epicGamesNav.browser = bowser_1.default.parse(userAgent);
    const navBrowser = (0, epic_games_nav_shared_1.getBrowserFlags)(userAgent);
    Object.assign(window_or_global_1.default._epicGamesNav.browser, navBrowser);
};
exports.setRootUAFlags = setRootUAFlags;
const initBowser = (userAgent, force) => {
    if (!window_or_global_1.default._epicGamesNav) {
        window_or_global_1.default._epicGamesNav = defaultEpicGamesNav;
    }
    if ((force || !window_or_global_1.default._epicGamesNav.browser || !window_or_global_1.default._epicGamesNav.browser._init) &&
        window_or_global_1.default.navigator &&
        window_or_global_1.default.navigator.userAgent) {
        try {
            (0, exports.setRootUAFlags)(window_or_global_1.default.navigator.userAgent);
        }
        catch (e) {
            //
        }
        window_or_global_1.default._epicGamesNav.browser._init = true;
    }
    if (userAgent) {
        return (0, epic_games_nav_shared_1.getBrowserFlags)(userAgent);
    }
    return window_or_global_1.default._epicGamesNav.browser;
};
exports.initBowser = initBowser;
let userAgentSet = false;
const setUserAgent = () => {
    const body = window_or_global_1.default.document.body;
    if (!userAgentSet) {
        userAgentSet = true;
        for (const key in bowser_1.default) {
            if (typeof key === "string" &&
                typeof bowser_1.default[key] !== "function" &&
                key.length > 1 &&
                key !== "name" &&
                key !== "version") {
                (0, common_1.setDataAttribute)(body, key, true);
            }
        }
    }
};
exports.setUserAgent = setUserAgent;
const initReadyChecks = () => {
    //allow external sites to apply logic when the header is rendered
    if (typeof window_or_global_1.default._egNavReadyCallback === "function") {
        window_or_global_1.default._egNavReadyCallback();
        window_or_global_1.default._egNavReadyCallbackRun = true;
    }
    else {
        //start loop in case callback is created late
        let readyChecks = 0;
        const readyCheck = setInterval(() => {
            try {
                readyChecks++;
                if (window_or_global_1.default && window_or_global_1.default._egNavReadyCallback && typeof window_or_global_1.default._egNavReadyCallback === "function") {
                    window_or_global_1.default._egNavReadyCallback();
                    window_or_global_1.default._egNavReadyCallbackRun = true;
                    clearInterval(readyCheck);
                }
                if (readyChecks > 10) {
                    clearInterval(readyCheck);
                }
            }
            catch (e) {
                clearInterval(readyCheck);
            }
        }, 500);
    }
    window_or_global_1.default._egNavReadyCallbackCalled = true;
};
exports.initReadyChecks = initReadyChecks;
//# sourceMappingURL=globalNavUtils.js.map